import { Injectable, NgZone } from '@angular/core';
import IPluginDefinition = CKEDITOR.plugins.IPluginDefinition;
import { DialogService, IDialogHandle } from '../dialogs/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import editor = CKEDITOR.editor;
import { ImageManagerDialogComponent } from '../file-manager/manager-dialog/image-manager-dialog.component';
import { DialogCloseReason, IDialogOnClose } from '../dialogs/base-dialog';
import { IImageFile } from '../interfaces/files.interface';

@Injectable({ providedIn: 'root' }) //consume this service as Injectable so we could have the translation service injected to it.
export class CkEditorInsertImagePluginService implements IPluginDefinition {
  static imageLinkEnabled: boolean = true;

  toolbarTooltipCaption: string;

  constructor(
    private dialogService: DialogService,
    public zone: NgZone,
    private translate: TranslateService
  ) {
    this.toolbarTooltipCaption = this.translate.instant('COMMON.CK_EDITOR_INSERT_IMAGE_PLUGIN.CK_EDITOR_BUTTON_LABEL');
    CKEDITOR.plugins.add('cd-insert-image', this);
    //followed this link that helped me a lot https://gist.github.com/kevinchampion/5355372
    CKEDITOR.on('dialogDefinition', function (ev: any) {
      let dialogName = ev.data.name;
      let dialogDefinition = ev.data.definition;

      switch (dialogName) {
        case 'image': //Image Properties dialog
          dialogDefinition.removeContents('advanced');
          if (!CkEditorInsertImagePluginService.imageLinkEnabled) {
            dialogDefinition.removeContents('Link');
          }
          var inforTab = dialogDefinition.getContents('info');
          inforTab.elements[0].children[0].children.forEach((child: any) => {
            child.hidden = true;
          });
          break;
      }
    });
  }

  init(editor: editor): any {
    let pluginInstance = this;

    editor.addCommand('cdInsertImageCommand', {
      exec: (editor: editor) => {
        pluginInstance.zone.run(() => {
          let dialogHandle: IDialogHandle;
          dialogHandle = this.dialogService.createDialog<ImageManagerDialogComponent>(ImageManagerDialogComponent);

          dialogHandle.onClose.subscribe((result: IDialogOnClose) => {

            if (result.reason === DialogCloseReason.OK) {
              let resultImageFile: IImageFile = result.data.selectedFile as IImageFile;

              // var imageSrcUrl = e.sender.originalElement.$.src;
              // var width = e.sender.originalElement.$.width;
              // var height = e.sender.originalElement.$.height;
              var imgHtml = CKEDITOR.dom.element.createFromHtml(
                `<img class="ck-editor-embedded-image" src="${resultImageFile.src}" style="vertical-align: text-bottom; border-color: #000000;"/>`
              );

              editor.insertElement(imgHtml);
            }
          });

        });
        return true;
      }
    });

    if (editor.ui.addButton) {
      editor.ui.addButton('CdInsertImage', {
        label: this.toolbarTooltipCaption,
        command: 'cdInsertImageCommand',
        toolbar: 'clickDimensionsActions',
        icon: `/assets/images/image-place-holder-icon.png`
      });
    }
  }
}
